// extracted by mini-css-extract-plugin
module.exports = {"callToActionContainer":"ChallengeDetail_callToActionContainer__de-Mh"};